<template>
  <div class="cxm-OpenQuestion">
    <Input
      :placeholder="commentPlaceholder"
      :value="answer"
      autogrow
      class="cxm-OpenQuestion-Input"
      type="textarea"
      :maxlength="maxSizeQuestion"
      @blur="$emit('blur', $event)"
      @input="handleAnswerChange"
    />
    <span
      data-test-id="open_contador"
      class="cxm-OpenQuestion-SizeQuestion"
    >{{ sizeQuestion }}</span>
  </div>
</template>

<script>
import Input from '../../Input/Input.vue';

export default {
  components: { Input },
  props: {
    answer: {
      default: '',
      type: String,
    },
    commentPlaceholder: {
      default: '',
      type: String,
    },
    questionData: {
      default: () => ({}),
      type: Object,
    },
    language: {
      default: 'pt_BR',
      type: String,
    },
  },
  data() {
    return {
      debounceInputEmitTimeout: null,
      maxSizeQuestion: 5000,
    };
  },
  computed: {
    getLanguage() {
      if (this.language === 'en_US') {
        return 'characters';
      }
      return 'caracteres';
    },
    sizeQuestion() {
      return `${this.maxSizeQuestion - String(this.answer).length} / ${this.maxSizeQuestion} ${this.getLanguage}`;
    },
  },
  methods: {
    handleAnswerChange(value) {
      this.$emit('change', value);
    },
  },
};
</script>

<style lang="scss" scoped>
.cxm-OpenQuestion {
  width: 100%;
}
.cxm-OpenQuestion-Input {
  width: 100%;
}
.cxm-OpenQuestion-SizeQuestion {
  color: var(--track-color-bluegray-80);
  font-family: var(--track-font-family-base);
  font-size: var(--track-font-size-xxs);
  font-weight: var(--track-font-weight-medium);
  line-height: 140%;
  margin-top: var(--track-spacing-xs);
}
</style>
